// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3G1dkfNKMT3fIbZ4YUaXLS {\n  display: flex;\n}\n\n._12b7jUoWvAcRuUkOeiWAty {\n  margin-left: 5px;\n  font-size: 18px;\n  color: #999;\n  outline: none;\n}\n\n._12b7jUoWvAcRuUkOeiWAty:hover {\n  color: #D0021B;\n}", ""]);
// Exports
exports.locals = {
	"rating": "_3G1dkfNKMT3fIbZ4YUaXLS",
	"clearBtn": "_12b7jUoWvAcRuUkOeiWAty"
};
module.exports = exports;
